/* ============================================================
   NH · Cart Drawer Auto-Open (global hook)
   Objetivo: CUALQUIER add-to-cart abre el carrito lateral (drawer)
   con el item agregado, SIN navegar a /cart.

   Como funciona:
   1) Parchea window.fetch y XMLHttpRequest. Toda respuesta exitosa
      de POST /cart/add(.js) sin parametro "sections" (= el llamador no
      refresca el drawer por si mismo) dispara: refresh del drawer via
      Section Rendering API + apertura con animacion + resaltado del item.
      La promesa devuelta al llamador NUNCA se resuelve en caso de exito:
      asi los buy-boxes antiguos que hacian location.href='/cart' (o
      '/checkout') en su .then() ya NO navegan (no se puede stubbar
      window.location de forma fiable; mantener la promesa pendiente es lo
      mas robusto). Como ese codigo tampoco restaura su boton, el hook
      restaura por su cuenta cualquier boton que quedo en "AGREGANDO..."/
      disabled (snapshot del estado original via listener en capture).
      En caso de error la promesa sigue su curso normal (fallback intacto).
   2) Intercepta en capture los <form action="/cart/add"> tradicionales
      (que navegaban con return_to=/cart) y los convierte a add AJAX.
   3) Los flujos que YA manejan el drawer (product-form Dawn, quick-add
      data-nh-qadd, bundle-deals, buy-strip, add-ons del drawer, popup
      tnp) envian "sections" en el body => el hook los deja pasar intactos.
   4) Desactivado dentro de /cart (alli el carrito ya es la pagina).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nhCartHook) return;
  window.__nhCartHook = 1;

  // No interceptar dentro de la pagina del carrito (alli hay flujos con reload propio)
  if (/(^|\/)cart(\/|$)/.test(window.location.pathname)) return;

  var ADD_RE = /\/cart\/add(\.js)?(\?|#|$)/i;

  function getDrawer() { return document.querySelector('cart-drawer'); }

  function bodyHasSections(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') {
        return body.indexOf('"sections"') !== -1 || /(^|&)sections=/.test(body);
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }

  /* ---------- Rescate de botones "AGREGANDO..." (fix P0) ----------
     Los buy-boxes antiguos hacen: btn.disabled=true; btn.innerHTML='AGREGANDO...'
     y restauran en el .catch() o navegan en el .then(). Como el hook suprime la
     navegacion (promesa pendiente en exito), el boton quedaba atascado.
     Solucion: snapshot del estado original del boton en capture (antes de que el
     handler del template lo modifique) y, tras un add exitoso, restaurar texto
     original + disabled=false en todos los botones afectados. */
  var NH_BUSY_RE = /agregando|adding|procesando|enviando/i;

  function nhSnapshotBtn(b) {
    try {
      if (!b || b.dataset.nhOrigHtml !== undefined) return;
      b.dataset.nhOrigHtml = b.innerHTML;
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      var b = t && t.closest ? t.closest('button, [type="submit"], [role="button"], a.btn, a.button') : null;
      if (b) nhSnapshotBtn(b);
    } catch (err) {}
  }, true);

  function nhResetAddButtons() {
    try {
      var all = document.querySelectorAll('[data-nh-orig-html], button, [type="submit"], [role="button"]');
      for (var i = 0; i < all.length; i++) {
        var b = all[i];
        var busy = NH_BUSY_RE.test((b.textContent || '').trim());
        var hasOrig = b.dataset && b.dataset.nhOrigHtml !== undefined;
        if (!busy && !b.disabled && b.getAttribute('aria-disabled') !== 'true') continue;
        if (hasOrig && busy) {
          try { b.innerHTML = b.dataset.nhOrigHtml; } catch (e) {}
        }
        if (busy || (hasOrig && b.disabled)) {
          try { b.disabled = false; } catch (e) {}
          b.removeAttribute('disabled');
          b.removeAttribute('aria-disabled');
          b.classList.remove('disabled', 'is-loading', 'loading');
        }
      }
    } catch (e) {}
  }

  function nhScheduleBtnReset() {
    setTimeout(nhResetAddButtons, 120);
    setTimeout(nhResetAddButtons, 600);
    setTimeout(nhResetAddButtons, 1600);
  }

  /* ---------- Refresh del drawer + apertura + resaltado ---------- */
  function inner(html, sel) {
    try {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var el = d.querySelector(sel);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function highlightItems(variantIds) {
    if (!variantIds || !variantIds.length) return;
    try {
      variantIds.forEach(function (vid) {
        var el = document.querySelector('#CartDrawer [data-variant-id="' + vid + '"], #CartDrawer [data-quantity-variant-id="' + vid + '"]');
        var row = el && el.closest ? (el.closest('tr.cart-item') || el.closest('.cart-item')) : null;
        if (!row) return;
        row.classList.remove('nh-item-just-added');
        void row.offsetWidth;
        row.classList.add('nh-item-just-added');
        try { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { row.scrollIntoView(); }
        setTimeout(function () { row.classList.remove('nh-item-just-added'); }, 2600);
      });
    } catch (e) {}
  }

  function bindOverlayClose(dr) {
    try {
      var ov = dr.querySelector('#CartDrawer-Overlay');
      if (ov && typeof dr.close === 'function' && !ov.dataset.nhClose) {
        ov.dataset.nhClose = '1';
        ov.addEventListener('click', function () { dr.close(); });
      }
    } catch (e) {}
  }

  function refreshOpenDrawer(variantIds) {
    var done = function () {
      var dr = getDrawer();
      if (!dr) return;
      bindOverlayClose(dr);
      dr.classList.remove('is-empty');
      var di = dr.querySelector('.drawer__inner');
      if (di) di.classList.remove('is-empty');
      try {
        if (typeof dr.open === 'function') dr.open();
        else { dr.classList.add('active'); document.body.classList.add('overflow-hidden'); }
      } catch (e) {}
      highlightItems(variantIds);
    };
    // Reutiliza el refresher del drawer si existe (mismo criterio de secciones)
    if (typeof window.nhRefreshDrawer === 'function') {
      try {
        var r = window.nhRefreshDrawer();
        if (r && typeof r.then === 'function') return r.then(function () { var dr = getDrawer(); if (dr) bindOverlayClose(dr); highlightItems(variantIds); });
        done(); return Promise.resolve();
      } catch (e) { /* fallback abajo */ }
    }
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s['cart-drawer']) {
          var html = inner(s['cart-drawer'], '#CartDrawer');
          var target = document.querySelector('#CartDrawer');
          if (html != null && target) target.innerHTML = html;
        }
        if (s['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          if (b) b.innerHTML = inner(s['cart-icon-bubble'], '.shopify-section') || s['cart-icon-bubble'];
        }
        done();
      })
      .catch(function () {});
  }

  function variantIdsFromAddResponse(json) {
    try {
      if (json && json.items && json.items.length) {
        return json.items.map(function (it) { return String(it.variant_id || it.id); });
      }
      if (json && (json.variant_id || json.id)) return [String(json.variant_id || json.id)];
    } catch (e) {}
    return [];
  }

  /* ---------- 1) Parche de fetch ---------- */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var method = 'GET';
      try { method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase(); } catch (e) {}
      var isAdd = method === 'POST' && ADD_RE.test(url);
      // Sin drawer en la pagina o llamador auto-gestionado (sections): comportamiento intacto
      if (!isAdd || !getDrawer() || bodyHasSections(init && init.body)) {
        return _fetch.apply(this, arguments);
      }
      return _fetch.apply(this, arguments).then(function (resp) {
        if (!resp || !resp.ok) return resp; // error: el llamador conserva su fallback
        try {
          resp.clone().json().then(function (j) {
            refreshOpenDrawer(variantIdsFromAddResponse(j));
            nhScheduleBtnReset();
          }).catch(function () { refreshOpenDrawer([]); nhScheduleBtnReset(); });
        } catch (e) { refreshOpenDrawer([]); nhScheduleBtnReset(); }
        // NUNCA resolver en exito: suprime el location.href='/cart'|'/checkout'
        // que los buy-boxes antiguos ejecutan en su .then()
        return new Promise(function () {});
      });
    };
  }

  /* ---------- 2) Parche de XMLHttpRequest (red de seguridad) ---------- */
  try {
    var X = window.XMLHttpRequest;
    if (X && X.prototype) {
      var _open = X.prototype.open;
      var _send = X.prototype.send;
      X.prototype.open = function (method, url) {
        this.__nhIsAdd = String(method).toUpperCase() === 'POST' && ADD_RE.test(String(url || ''));
        return _open.apply(this, arguments);
      };
      X.prototype.send = function (body) {
        if (this.__nhIsAdd && getDrawer() && !bodyHasSections(body)) {
          this.addEventListener('load', function () {
            try {
              if (this.status >= 200 && this.status < 300) {
                var ids = [];
                try { ids = variantIdsFromAddResponse(JSON.parse(this.responseText)); } catch (e) {}
                refreshOpenDrawer(ids);
                nhScheduleBtnReset();
              }
            } catch (e) {}
          });
        }
        return _send.apply(this, arguments);
      };
    }
  } catch (e) {}

  /* ---------- 3) Forms tradicionales action="/cart/add" (return_to=/cart) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (e.defaultPrevented) return;                        // otro handler ya lo tomo
    if (f.closest && f.closest('product-form')) return;    // Dawn product-form ya hace AJAX + drawer
    var dr = getDrawer();
    if (!dr) return;                                       // sin drawer: comportamiento original
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(f);
    fd.delete('return_to');
    try {
      fd.append('sections', dr.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    } catch (err) {}
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.removeAttribute('aria-disabled');
      if (res && res.status && res.status !== 200) { window.location.href = '/cart'; return; }
      if (res && res.sections && typeof dr.renderContents === 'function') {
        dr.classList.remove('is-empty');
        dr.renderContents(res); // incluye open()
        highlightItems(variantIdsFromAddResponse(res));
      } else {
        refreshOpenDrawer(variantIdsFromAddResponse(res));
      }
    }).catch(function () {
      if (btn) btn.removeAttribute('aria-disabled');
      window.location.href = '/cart';
    });
  }, true);

  /* ---------- 4) API publica minima ---------- */
  window.NH_OPEN_CART_DRAWER = function (variantIds) { return refreshOpenDrawer(variantIds || []); };
})();

/* ================= NH un-boton drawer =================
   EasySell inyecta #es-popup-button.es-popup-button-drawer DENTRO del drawer
   (con inline styles !important). Lo ocultamos SIEMPRE por JS:
   el drawer solo lleva nuestro #CartDrawer-Checkout (verde, con temblor),
   que abre el popup COD via window.openTysloForm(true). */
(function(){
  var SEL = 'cart-drawer .es-popup-button, cart-drawer .es-popup-button-drawer, cart-drawer .es-button, cart-drawer [id^="es-popup"]';
  function hideEs(root){
    try{
      (root || document).querySelectorAll(SEL).forEach(function(el){
        el.style.setProperty('display','none','important');
      });
    }catch(e){}
  }
  hideEs();
  if('MutationObserver' in window){
    new MutationObserver(function(muts){
      var again = false;
      muts.forEach(function(m){
        if(!m.addedNodes) return;
        m.addedNodes.forEach(function(n){
          if(n.nodeType !== 1) return;
          if(n.closest && n.closest('cart-drawer')) again = true;
          if(n.matches && n.matches('.es-popup-button, .es-button')) again = true;
        });
      });
      if(again) hideEs();
    }).observe(document.documentElement, {childList:true, subtree:true});
  }
  /* refuerzo: EasySell re-pinta inline styles en cada refresh del drawer */
  setInterval(hideEs, 1200);
})();


/* ================= NH Thank-you FULL-PAGE (estilo order-status) =================
   El owner no quiere modal: al enviar el form COD, interceptamos
   window.EasySellHelpers.showThanksModal y pintamos una PÁGINA completa
   de confirmación. Guardamos los datos en sessionStorage y cambiamos la URL
   a /cart?gracias=1&pedido=NNN; al recargar /cart con gracias=1 se vuelve a
   pintar la misma página (persistencia). */
(function(){
  if(window.__nhThanksFull) return;
  window.__nhThanksFull = true;

  var TY_CSS =
    'html.nhty-lock,body.nhty-lock{overflow:hidden!important}' +
    'body.nhty-lock>*:not(#nhty-page):not(script):not(style):not(link):not(noscript){display:none!important}' +
    '#nhty-page{position:fixed;inset:0;z-index:2147483000;background:#fff;overflow-y:auto;-webkit-overflow-scrolling:touch;font-family:-apple-system,"Segoe UI",Roboto,Arial,sans-serif;color:#2A2118;line-height:1.45}' +
    '#nhty-page *{box-sizing:border-box}' +
    '.nhty-hd{max-width:640px;margin:0 auto;padding:24px 18px 10px;position:relative;display:flex;justify-content:center;align-items:center}' +
    '.nhty-hd img{width:190px;max-width:52vw;height:auto;display:block}' +
    '.nhty-user{position:absolute;right:18px;top:50%;transform:translateY(-50%);width:32px;height:32px;border-radius:50%;border:1.5px solid #E3DCCB;display:flex;align-items:center;justify-content:center;color:#1E3D24;opacity:.75}' +
    '.nhty-user svg{width:18px;height:18px;fill:#1E3D24}' +
    '.nhty-prow{display:flex;align-items:center;gap:12px;padding:5px 0}' +
    '.nhty-thumbw{position:relative;flex:none}' +
    '.nhty-thumb{width:60px;height:60px;object-fit:cover;border-radius:12px;border:1px solid #E9E2D2;background:#F5F1E8;display:block}' +
    '.nhty-qty{position:absolute;top:-7px;right:-7px;min-width:19px;height:19px;border-radius:50%;background:#1E3D24;color:#fff;font-size:11px;font-weight:800;display:flex;align-items:center;justify-content:center;padding:0 4px;box-shadow:0 2px 6px rgba(0,0,0,.25)}' +
    '.nhty-pname{flex:1;font-size:14px;font-weight:600;color:#2A2118;line-height:1.35}' +
    '.nhty-main{max-width:640px;margin:0 auto;padding:10px 18px 40px}' +
    '.nhty-title{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin:10px 0 16px;flex-wrap:wrap}' +
    '.nhty-title h1{font-size:21px;font-weight:800;color:#1E3D24;margin:0;display:flex;align-items:center;gap:8px}' +
    '.nhty-title h1 a{color:#1E3D24;text-decoration:none;font-weight:400}' +
    '.nhty-date{font-size:13px;color:#7A8571;margin:4px 0 0 28px}' +
    '.nhty-pill{flex:none;background:#fff;border:1.5px solid #2E7D4F;color:#1E3D24;font-weight:700;font-size:13px;padding:8px 16px;border-radius:99px;text-decoration:none}' +
    '.nhty-card{background:#fff;border:1px solid #E9E2D2;border-radius:16px;padding:16px 18px;margin:0 0 14px;box-shadow:0 4px 16px rgba(30,61,36,.05)}' +
    '.nhty-big{font-size:17px;font-weight:800;color:#1E3D24;margin:0 0 6px}' +
    '.nhty-mut{font-size:13px;color:#6B7A66;margin:0}' +
    '.nhty-conf{display:flex;gap:10px;align-items:flex-start}' +
    '.nhty-check{flex:none;width:24px;height:24px;border-radius:50%;background:#2E7D4F;color:#fff;font-size:14px;font-weight:800;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.nhty-conf b{display:block;font-size:15px;color:#1E3D24}' +
    '.nhty-conf span{display:block;font-size:13px;color:#4A5648;margin-top:2px}' +
    '.nhty-conf small{display:block;font-size:12px;color:#9AA28F;margin-top:3px}' +
    '.nhty-prod{padding:4px 0 10px;border-bottom:1px solid #F0EBDD;margin-bottom:10px}' +
    '.nhty-prod div{display:flex;justify-content:space-between;gap:10px;font-size:14px;font-weight:600;color:#2A2118;padding:3px 0}' +
    '.nhty-row{display:flex;justify-content:space-between;font-size:13.5px;color:#4A5648;padding:4px 0}' +
    '.nhty-row b{color:#2A2118}' +
    '.nhty-tot{display:flex!important;justify-content:space-between;align-items:baseline;border-top:2px solid #1E3D24;margin-top:8px;padding-top:10px;font-size:16px;font-weight:800;color:#1E3D24}' +
    '.nhty-lbl{color:#8A8F7E;font-size:13px;width:88px;flex:none}' +
    '.nhty-kv{display:flex;gap:14px;padding:4px 0}' +
    '.nhty-kv div:last-child{font-size:13.5px;color:#2A2118;line-height:1.5}' +
    '#nhty-page a.nhty-wa{display:flex!important;visibility:visible!important;opacity:1!important;align-items:center;justify-content:center;gap:8px;background:#25D366!important;color:#fff!important;text-decoration:none!important;border-radius:99px;padding:14px;font-size:15.5px;font-weight:800;margin:4px 0 10px;box-shadow:0 10px 22px rgba(37,211,102,.3)}' +
    '.nhty-back{display:block;text-align:center;font-size:13.5px;font-weight:700;color:#2E7D4F;text-decoration:none;padding:6px 0 14px}' +
    '.nhty-ft{text-align:center;font-size:11.5px;color:#8A8F7E;padding:8px 18px 26px;border-top:1px solid #F0EBDD;max-width:640px;margin:0 auto}' +
    '.nhty-ft b{color:#1E3D24}' +
    '@media(max-width:480px){.nhty-hd img{width:150px;max-width:56vw}.nhty-title h1{font-size:19px}}';

  var MESES=['ene','feb','mar','abr','may','jun','jul','ago','sept','oct','nov','dic'];
  function tyFecha(ts){ var d=ts?new Date(ts):new Date(); return d.getDate()+' '+MESES[d.getMonth()]; }
  function tyPhone(p){
    var dig=String(p||'').replace(/\D/g,'');
    if(/^507\d{8}$/.test(dig)) return '+507 '+dig.slice(3);
    if(/^\d{8}$/.test(dig)) return '+507 '+dig;
    return String(p||'');
  }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function tyEnsureCss(){
    if(document.getElementById('nhty-style')) return;
    var st=document.createElement('style');
    st.id='nhty-style';
    st.textContent=TY_CSS;
    document.head.appendChild(st);
  }

  /* ---------- extracción de datos del thankyou_text procesado ---------- */
  function tyExtract(origHtml){
    var d={order:'',name:'',products:[],total:''};
    try{
      var doc=new DOMParser().parseFromString(String(origHtml||''),'text/html');
      var txt=(doc.body.textContent||'').replace(/\s+/g,' ').trim();
      var m;
      m=txt.match(/Pedido\s*#\s*([0-9]+)/i); if(m) d.order=m[1];
      m=txt.match(/Gracias,\s*([^!.,\n]+)/i); if(m) d.name=m[1].trim();
      m=txt.match(/TOTAL A PAGAR AL RECIBIR\s*:?\s*(\$?\s*[\d][\d.,]*)/i); if(m) d.total=m[1].replace(/\s+/g,'');
      /* productos: del HTML entre RESUMEN DE TU PEDIDO y Envío */
      var html=doc.body.innerHTML;
      var i1=html.search(/RESUMEN DE TU PEDIDO/i);
      var i2=html.search(/Env[íi]o\s*:/i);
      if(i1>=0 && i2>i1){
        var seg=html.slice(i1,i2).replace(/RESUMEN DE TU PEDIDO/i,'');
        seg.split(/<br\s*\/?>/i).forEach(function(line){
          var t=line.replace(/<[^>]*>/g,' ').replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu,'').replace(/[\u2014\u2013-]{3,}/g,' ').replace(/\s+/g,' ').trim();
          if(t) d.products.push(t);
        });
      }
      var clean=function(s){return String(s||'').replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu,'').replace(/[\u2014\u2013]{3,}/g,' ').replace(/\s+/g,' ').trim();};
      d.name=clean(d.name); d.total=clean(d.total);
    }catch(e){}
    return d;
  }

  /* ---------- captura de campos del formulario EasySell ---------- */
  function tyCaptureForm(d){
    try{
      var g=function(sel){
        var el=document.querySelector(sel);
        if(!el) return '';
        if(el.tagName==='SELECT'){ var o=el.options[el.selectedIndex]; return o?o.textContent.trim():''; }
        return (el.value||'').trim();
      };
      d.phone=g('#es-phone');
      d.address=g('#es-address');
      d.address2=g('#es-address2');
      d.province=g('#es-province');
      d.city=g('#es-city');
      if(!d.name) d.name=g('#es-first_name');
      /* imagen: drawer/cart primero, og:image de la PDP como respaldo */
      var im=document.querySelector('cart-drawer .cart-item img, cart-drawer img.cart-item__image, cart-drawer .cart-item__media img');
      if(im && im.src) d.img=im.src;
      if(!d.img){ var og=document.querySelector('meta[property="og:image"]'); if(og && og.content) d.img=og.content; }
      var q=document.querySelector('cart-drawer input.quantity__input');
      if(q && q.value) d.qty=q.value;
    }catch(e){}
    return d;
  }

  function tySave(d){
    d.ts=Date.now();
    try{ sessionStorage.setItem('nh_last_order_confirmation', JSON.stringify(d)); }catch(e){}
    return d;
  }
  function tyLoad(){
    try{ return JSON.parse(sessionStorage.getItem('nh_last_order_confirmation')||'null'); }catch(e){ return null; }
  }

  /* ---------- render de la página completa ---------- */
  function tyRender(d){
    tyEnsureCss();
    d=d||{};
    var order=esc(d.order), name=esc(d.name), total=esc(d.total);
    var fecha=tyFecha(d.ts);
    var prods=(d.products||[]).map(esc);

    var h='<div id="nhty-page">';
    /* header */
    h+='<div class="nhty-hd"><a href="/"><img src="https://cdn.shopify.com/s/files/1/0739/9548/5315/files/natural-hubb-logo-transparente-sin-fondo.png" alt="Natural Hubb"></a><span class="nhty-user"><svg viewBox="0 0 24 24"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg></span></div>';
    h+='<div class="nhty-main">';
    /* título */
    h+='<div class="nhty-title"><div><h1><a href="/">←</a> Pedido '+(order?'#'+order:'')+'</h1><p class="nhty-date">Fecha de confirmación: '+fecha+'</p></div><a class="nhty-pill" href="/">Seguir comprando</a></div>';
    /* pago pendiente */
    h+='<div class="nhty-card"><p class="nhty-big">'+(total?total+' USD':'Pago contra entrega')+'</p><p class="nhty-mut">Este pedido tiene un pago pendiente. Se actualizará cuando recibas y pagues tu pedido.</p></div>';
    /* confirmado */
    h+='<div class="nhty-card"><div class="nhty-conf"><span class="nhty-check">✓</span><div><b>Confirmado</b><span>'+(name?'¡Gracias, '+name+'! ':'')+'Estamos preparando estos artículos para el envío.</span><small>'+fecha+' · Entrega estimada 24–48 h</small></div></div></div>';
    /* resumen */
    h+='<div class="nhty-card">';
    if(prods.length){
      h+='<div class="nhty-prod">';
      prods.forEach(function(p,idx){
        if(idx===0 && d.img){
          h+='<div class="nhty-prow"><span class="nhty-thumbw"><img class="nhty-thumb" src="'+esc(d.img)+'" alt="" loading="lazy">'
            +(d.qty && String(d.qty)!=='1'?'<span class="nhty-qty">'+esc(d.qty)+'</span>':'')
            +'</span><span class="nhty-pname">'+p+'</span></div>';
        }else{
          h+='<div class="nhty-prow"><span class="nhty-pname">'+p+'</span></div>';
        }
      });
      h+='</div>';
    }
    if(total) h+='<div class="nhty-row"><span>Subtotal</span><b>'+total+'</b></div>';
    h+='<div class="nhty-row"><span>Envío · todo Panamá 🇵🇦</span><b>Gratis</b></div>';
    if(total) h+='<div class="nhty-tot"><span>Total</span><span><small style="font-weight:400;color:#8A8F7E">USD</small> '+total+'</span></div>';
    h+='</div>';
    /* contacto */
    h+='<div class="nhty-card"><div class="nhty-kv"><span class="nhty-lbl">Contacto</span><div>'+(d.phone?esc(tyPhone(d.phone)):'Te contactaremos por WhatsApp en los próximos minutos 📱')+'</div></div></div>';
    /* enviar a */
    var dir=[];
    if(d.name) dir.push(esc(d.name).toUpperCase());
    if(d.address) dir.push(esc(d.address));
    if(d.address2) dir.push(esc(d.address2));
    var cp=[d.city,d.province].filter(Boolean).map(esc).join(', ');
    if(cp) dir.push(cp);
    if(d.phone) dir.push(esc(tyPhone(d.phone)));
    h+='<div class="nhty-card"><div class="nhty-kv"><span class="nhty-lbl">Enviar a</span><div>'+(dir.length?dir.join('<br>'):'Coordinamos la dirección exacta por WhatsApp contigo.')+'</div></div>';
    h+='<div class="nhty-kv" style="border-top:1px solid #F0EBDD;margin-top:8px;padding-top:12px"><span class="nhty-lbl">Método</span><div>Envío gratis</div></div>';
    h+='<div class="nhty-kv" style="border-top:1px solid #F0EBDD;margin-top:8px;padding-top:12px"><span class="nhty-lbl">Pago</span><div>Pago contra entrega<br><small style="color:#8A8F7E">'+(total?total+' USD · ':'')+fecha+'</small></div></div></div>';
    /* CTA + volver */
    h+='<a class="nhty-wa" href="https://wa.me/50764076156?text=Hola%20Natural%20Hubb%2C%20acabo%20de%20hacer%20el%20pedido'+(order?'%20%23'+encodeURIComponent(order):'')+'%20%F0%9F%99%8C">💬 Escríbenos por WhatsApp</a>';
    h+='<a class="nhty-back" href="/">Volver a la tienda</a>';
    h+='</div>';
    h+='<div class="nhty-ft">🔒 <b>Pago contra entrega</b> · Sin tarjeta · Sin adelantos · Envío gratis a todo Panamá 🇵🇦</div>';
    h+='</div>';

    var old=document.getElementById('nhty-page');
    if(old) old.remove();
    document.body.insertAdjacentHTML('beforeend', h);
    document.documentElement.classList.add('nhty-lock');
    document.body.classList.add('nhty-lock');
    /* ocultar el popup del form si quedó abierto */
    var em=document.getElementById('easysell-modal');
    if(em) em.style.setProperty('display','none','important');
    window.scrollTo(0,0);
  }

  /* ---------- detección temprana: reload de /cart?gracias=1 ---------- */
  function tyCheckLanding(){
    try{
      var u=new URL(window.location.href);
      if(u.pathname.replace(/\/+$/,'')==='/cart' && u.searchParams.get('gracias')==='1'){
        var d=tyLoad()||{};
        if(!d.order){ var p=u.searchParams.get('pedido'); if(p) d.order=p; }
        var go=function(){ tyRender(d); };
        if(document.body) go(); else document.addEventListener('DOMContentLoaded', go);
      }
    }catch(e){}
  }
  tyCheckLanding();

  /* ---------- wrapper sobre showThanksModal ---------- */
  function tyWrap(){
    var H=window.EasySellHelpers;
    if(!H || typeof H.showThanksModal!=='function') return false;
    if(H.__nhtyWrapped) return true;
    /* guardar referencia por si se necesita fallback manual */
    H.__nhtyOriginal=H.showThanksModal.bind(H);
    H.showThanksModal=function(origHtml){
      try{
        var d=tyExtract(origHtml);
        d=tyCaptureForm(d);
        tySave(d);
        try{ history.replaceState({},'', '/cart?gracias=1'+(d.order?'&pedido='+encodeURIComponent(d.order):'')); }catch(e){}
        tyRender(d);
        return;
      }catch(e){
        try{ return H.__nhtyOriginal.apply(null, arguments); }catch(e2){}
      }
    };
    H.__nhtyWrapped=true;
    return true;
  }
  var tyTries=0;
  var tyIv=setInterval(function(){
    tyTries++;
    if(tyWrap() || tyTries>80){ clearInterval(tyIv); }
  },250);
})();
